import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { Form, Button } from 'react-bootstrap';
import * as Yup from 'yup';
import RequiredIndicator from '../RequiredIndicator/RequiredIndicator';

const DiscountForm = ({ initialValues, onSubmit, edit , create}) => {
    
    const formik = useFormik({
        initialValues:initialValues,
        validationSchema: Yup.object({
            name: Yup.string().required("Обов'язкове поле"),
            quantity: Yup.string().required("Обов'язкове поле"),
            active: Yup.boolean().required("Обов'язкове поле"),
            dateEnd: Yup.string()
                .required("Обов'язкове поле")
                .test('not-expired-if-active', 'Неможливо активувати знижку з простроченою датою', function(value) {
                    const { active } = this.parent;
                    if (active && value) {
                        const selectedDate = new Date(value);
                        selectedDate.setHours(0, 0, 0, 0);
                        const currentDate = new Date();
                        currentDate.setHours(0, 0, 0, 0);
                        return selectedDate >= currentDate;
                    }
                    return true;
                }),
        }),
        onSubmit: (values, { resetForm }) => {
            onSubmit(values);
            resetForm();
        },
    });
    useEffect(() => {
        formik.setValues(initialValues);
    }, [initialValues]);

    return (
        <div>
            <Form onSubmit={formik.handleSubmit}>
                <Form.Group controlId="name">
                    <Form.Label>Назва <RequiredIndicator /></Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter name"
                        name="name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name}
                    />
                    {formik.touched.name && formik.errors.name ? (
                        <div className="text-danger">{formik.errors.name}</div>
                    ) : null}
                </Form.Group>
                <Form.Group controlId="quantity">
                    <Form.Label>Відсоток знижки <RequiredIndicator /></Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Введіть відсоток знижки"
                        name="quantity"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.quantity}
                    />
                    {formik.touched.quantity && formik.errors.quantity ? (
                        <div className="text-danger">{formik.errors.quantity}</div>
                    ) : null}
                </Form.Group>
                <Form.Group controlId="dateEnd">
                    <Form.Label>Дата завершення <RequiredIndicator /></Form.Label>
                    <Form.Control
                        type="date"
                        placeholder="Enter dateEnd"
                        name="dateEnd"
                        onChange={(e) => {
                            formik.handleChange(e);
                            // Автоматично вимикаємо активність, якщо дата прострочена
                            const selectedDate = new Date(e.target.value);
                            selectedDate.setHours(0, 0, 0, 0);
                            const currentDate = new Date();
                            currentDate.setHours(0, 0, 0, 0);
                            if (selectedDate < currentDate && formik.values.active) {
                                formik.setFieldValue('active', false);
                            }
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.dateEnd}
                        style={
                            formik.values.dateEnd && new Date(formik.values.dateEnd).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)
                                ? { borderColor: '#dc3545' }
                                : {}
                        }
                    />
                    {formik.values.dateEnd && new Date(formik.values.dateEnd).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0) && (
                        <div className="text-warning mt-1">
                            ⚠️ Увага: Вибрана дата вже минула. Знижка буде автоматично неактивною.
                        </div>
                    )}
                    {formik.touched.dateEnd && formik.errors.dateEnd ? (
                        <div className="text-danger">{formik.errors.dateEnd}</div>
                    ) : null}
                  </Form.Group>
                <Form.Group controlId="active">
                    <Form.Label>Active <RequiredIndicator /></Form.Label>
                    <Form.Check
                        type="switch"
                        id="active-checkbox"
                        name="active"
                        onBlur={formik.handleBlur}
                        checked={formik.values.active}
                        onChange={(e) => {
                            // Перевіряємо, чи дата не прострочена перед активацією
                            const selectedDate = new Date(formik.values.dateEnd);
                            selectedDate.setHours(0, 0, 0, 0);
                            const currentDate = new Date();
                            currentDate.setHours(0, 0, 0, 0);
                            
                            if (e.target.checked && selectedDate < currentDate) {
                                // Не дозволяємо активувати
                                return;
                            }
                            formik.setFieldValue('active', e.target.checked);
                        }}
                        disabled={formik.values.dateEnd && new Date(formik.values.dateEnd).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)}
                    />
                    {formik.values.dateEnd && new Date(formik.values.dateEnd).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0) && (
                        <div className="text-danger mt-1">
                            Неможливо активувати знижку з простроченою датою
                        </div>
                    )}
                    {formik.touched.active && formik.errors.active ? (
                        <div className="text-danger">{formik.errors.active}</div>
                    ) : null}
                </Form.Group>
                <Button variant="dark" type="submit">
                    {create && "Створити"} 
                    {edit && "Редагувати"}
                </Button>
            </Form>
        </div>
    );
};

export default DiscountForm;
